import {
    Constants
} from "../libs/Constants";
import {
    getBSConfig
} from "./BlackScholesObj";
import {
    getCompanyConfig
} from "./CompanyObj";
import {
    getPlanDetailsConfig
} from './PlanDetailsObj';
import {
    getPreRegisterConfig
} from "./PreRegisterUser";
import {
    getUserConfig
} from "./UserObj";
import {
    getOfferPeriodConfig
} from "./OfferPeriodObj";
import {
    getPeriodConfig
} from "./PeriodObj";


export function getConfig(type) {
    console.log("get config type=" + type);
    switch (type) {
        case Constants.dbTypes.COMPANY:
            return getCompanyConfig();
        case Constants.dbTypes.USER:
            return getUserConfig();
        case Constants.dbTypes.BLACK_SCHOLES:
            return getBSConfig();
        case Constants.dbTypes.COMPANY_SETTINGS:
        case Constants.dbTypes.CONTRIBUTION:
        case Constants.dbTypes.OFFERING_PERIOD:
            return getOfferPeriodConfig();
        case Constants.dbTypes.PERIOD:
            return getPeriodConfig();
        case Constants.dbTypes.PLAN_DETAILS:
            return getPlanDetailsConfig();
        case Constants.dbTypes.PRE_REGISTER:
            return getPreRegisterConfig();
        default:
            throw "empty object not yet implemented:" + type;
    }
}